import { ContactRole } from 'clickNgo/entities/contact'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'

export enum ContactRelinkingStep {
  Welcome,
  ReassignUniqueRoles,
  ReassignRoles,
  ReassignFlags,
  Backup,
  Completion,
}

export enum ContactRelinkingError {
  TargetPartnerNotFound = 'Target partner not found',
  FetchFail = 'Failed to fetch',
  RelinkContact = 'Failed to relink contact',
  ReassignRoles = "Failed to reassign roles.Contact wasn't relinked",
  ReassignFlags = "Failed to reassign flags.Contact wasn't relinked",
  // Add more error messages as needed
}

export const hierarchyTypesForAskingHowRemoveRoles = [
  PartnerHierarchyType.HEADQUARTERS,
  PartnerHierarchyType.AFFILIATE,
  PartnerHierarchyType.RESELLER_NETWORK,
]

export const rolesToKeepForBranchOnline = [ContactRole.HPChampion]

export const countriesWithoutPPAReassigningStep = ['JP']
